export default function PHP_parse_ini_string() {
  return (
    <div>
      <h1>PHP_parse_ini_string</h1>
    </div>
  );
}
